import { ACTIVE, INACTIVE } from '../constants';

const getStatusString = (isStatusActive: boolean) => {
  return isStatusActive ? ACTIVE : INACTIVE;
};

export { getStatusString };
